import { useContext, useEffect, useState } from "react";
import { WebSocketContext } from "../Context/WebSocketContext";
import { getData } from "../Services/getData";
import { endpoints } from "../Utils/UrlEnum";
import { OrderSource } from "../Utils/Constants";

/**
 * Custom hook to listen for unseen online orders count via WebSocket
 * Replaces polling with real-time updates from backend
 */
export const useUnprocessedOnlineClientsCount = (): number => {
  const [unprocessedCount, setUnprocessedCount] = useState(0);
  const { socket } = useContext(WebSocketContext);

  useEffect(() => {
    // Fetch initial count on mount
    const fetchInitialCount = async () => {
      try {
        const url = `${endpoints.ordersEndpoint}/paginated?source=${OrderSource.ONLINE}&unread=true&page=0&perPage=1`;
        const res = (await getData(url)) as any;

        if (res && !res?.error && res.data) {
          setUnprocessedCount(res.data.numberOfResults);
        }
      } catch (error) {
        console.error("Error fetching initial unseen orders count:", error);
      }
    };

    // Handle WebSocket updates for unseen orders count
    const handleUnseenOrdersUpdate = () => {
      fetchInitialCount();
    };

    // Fetch initial count
    fetchInitialCount();

    // Listen for real-time updates
    socket.on("unseenOrdersCount", handleUnseenOrdersUpdate);

    // Cleanup: remove event listener
    return () => {
      socket.off("unseenOrdersCount", handleUnseenOrdersUpdate);
    };
  }, [socket]);

  return unprocessedCount;
};
